import LoadingContext from './LoadingContext'

const LoadingConsumer = LoadingContext.Consumer ;

export default LoadingConsumer ;